import {
    EpgProgram,
    RBChannel,
    RBEditorial,
    RBProgram,
    RBRating,
    SearchDeeplink,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import {
    BtvEditorial,
    BtvProgramme,
    EventParentalControlRating,
    RBEventParentalControlRating,
    VodEditorial,
} from 'services/data-manager/types';

const RATING_CONVERSION_TABLE = {
    [RBEventParentalControlRating.HU_GENERAL]: undefined,
    [RBEventParentalControlRating.HU_UNRATED]: undefined,
    [RBEventParentalControlRating.HU6]: EventParentalControlRating.HU6,
    [RBEventParentalControlRating.HU12]: EventParentalControlRating.HU12,
    [RBEventParentalControlRating.HU16]: EventParentalControlRating.HU16,
    [RBEventParentalControlRating.HU18]: EventParentalControlRating.HU18,
    [RBEventParentalControlRating.HU18_ADULT]:
        EventParentalControlRating.HU18_ADULT,
    [RBEventParentalControlRating.HU18_ADULT_UC]:
        EventParentalControlRating.HU18_ADULT_UC,
    [RBEventParentalControlRating.UNKNOWN]: EventParentalControlRating.HU18,
};

function parseParentalRating(
    program:
        | VodEditorial
        | BtvEditorial
        | BtvProgramme
        | EpgProgram
        | RBProgram
        | RBEditorial
        | SearchDeeplink
        | RecordingMetadata
        | undefined,
    channel?: RBChannel,
): EventParentalControlRating | undefined {
    let ratings: RBRating[] | undefined;
    let isChannelRatings = false;

    if (program?.Ratings) {
        ratings = program.Ratings;
    } else if (channel?.editorial.Ratings) {
        ratings = channel.editorial.Ratings;
        isChannelRatings = true;
    }

    if (!ratings) {
        return EventParentalControlRating.HU16;
    }

    const parentalRating = ratings.find(
        (rating) => rating.ratingBody === 'HCRS',
    );

    const code = parentalRating?.code;
    const precedence = parentalRating?.precedence;

    if (code === RBEventParentalControlRating.HU_UNRATED && isChannelRatings) {
        return EventParentalControlRating.HU16;
    }

    if (
        code &&
        precedence !== undefined &&
        !Number.isNaN(precedence) &&
        Object.values(RBEventParentalControlRating).includes(code)
    ) {
        if (precedence < 6) {
            return EventParentalControlRating.HU_UNRATED;
        }

        if (precedence >= 6 && precedence < 12) {
            return EventParentalControlRating.HU6;
        }

        if (precedence >= 12 && precedence < 16) {
            return EventParentalControlRating.HU12;
        }

        if (precedence >= 16 && precedence < 18) {
            return EventParentalControlRating.HU16;
        }

        if (precedence >= 18 && precedence < 100) {
            return EventParentalControlRating.HU18;
        }

        if (precedence === 100) {
            return EventParentalControlRating.HU18_ADULT;
        }

        if (precedence > 100) {
            return EventParentalControlRating.HU18_ADULT_UC;
        }

        return RATING_CONVERSION_TABLE[code];
    }

    return EventParentalControlRating.HU18;
}

export default parseParentalRating;
